// @flow
import connectWebActions             from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents }      from 'fg-frontend/src/webComponents/decorate';
import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks                from 'fg-frontend/src/components/safeBlankLinks';
import cookiesPolicy                 from 'components/CookiesPolicy';
import phoneLink   		             from 'fg-frontend/components/PhoneLink';

import configureWebComponents from './configureWebComponents';
import configureWebActions    from './configureWebActions';

import 'fg-frontend/ramjet/liveValidation';
import 'bootstrap/js/dist/collapse';


connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, [ 'keyup' ]);
autoTitleLinksWithBlankTarget();
phoneLink();

// Mastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();


cookiesPolicy({
	imgSrc: '/img/cookies/bernard.png',
	template: data => `
      <section class="cookies-policy ${ data.disableRwdImg } ${ data.enableModal }" data-fragment="cp.pane">
        <div class="cookies-policy__container">
          ${ data.enableCloseButton ? `<button class="cookies-policy__btn-close" data-fragment="cp.closeButton"><span class="cookies-policy__btn-close-text">${ data.closeBtn }</span></button>` : '' }
          ${ data.enableImg ? `<header class="cookies-policy__header"><img class="cookies-policy__img" src="${ data.imgSrc }" alt="" /></header>` : '' }
          <div class="cookies-policy__main">
            <h2 class="cookies-policy__heading">${ data.heading }</h2>
            <p class="cookies-policy__perex">${ data.perex }</p>
            <div class="cookies-policy__buttons">
              <button class="cookies-policy__btn cookies-policy__btn--secondary" data-fragment="cp.acceptAllBtn">${ data.acceptAllBtn }</button>
              <button class="cookies-policy__btn cookies-policy__btn--secondary" data-fragment="cp.rejectButton">${ data.rejectBtn }</button>
              <button class="cookies-policy__btn cookies-policy__btn--secondary" data-fragment="cp.openSettingsButton">${ data.settingsBtn }</button>
            </div>
          </div>
        </div>
      </section>`,
	messages: {
		si: {
			heading: 'Keeping your site working well',
			perex: 'We want your browsing experience to be as pleasant as possible. That\'s why we use cookies, which help us constantly improve our website. They also allow us to show you relevant content and personalized ads. With your consent, we may share some data with our partners (e.g. Google). You can adjust your settings or withdraw your consent at any time. Find out more on the <a class="cookies-policy__link" href="/si/informacije-o-spletu">Information about the web</a> page.',
			closeBtn: 'Close',
			settingsBtn: 'Cookies settings',
			rejectBtn: 'Reject',
			acceptAllBtn: 'Enable all cookies',
		},
		se: {
			heading: 'Keeping your site working well',
			perex: 'We want your browsing experience to be as pleasant as possible. That\'s why we use cookies, which help us constantly improve our website. They also allow us to show you relevant content and personalized ads. With your consent, we may share some data with our partners (e.g. Google). You can adjust your settings or withdraw your consent at any time. Find out more on the <a class="cookies-policy__link" href="/se/information-om-webben">Information about the web</a> page.',
			closeBtn: 'Close',
			settingsBtn: 'Cookies settings',
			rejectBtn: 'Reject',
			acceptAllBtn: 'Enable all cookies',
		},
		ru: {
			perex: 'Мы хотим, чтобы просмотр нашего сайта был для вас максимально приятным. Поэтому мы используем файлы cookies, которые помогают нам постоянно улучшать сайт. Благодаря им мы также можем показывать вам релевантный контент и&nbsp;персонализированную рекламу. С вашего согласия мы можем передавать некоторые данные нашим партнерам (например, Google). Вы можете изменить настройки или отозвать согласие в&nbsp;любое время. Подробности на странице <a class="cookies-policy__link" href="/ru/information-about-the-web">Информация о&nbsp;сайте</a>.',
		},
	},
	settingsMessages: {
		si: {
			heading: 'Cookies settings',
			perex: 'You can set which cookies will be processed here. For more information, please go to <a class="cookies-settings__link" href="/si/informacije-o-spletu">Cookie information</a>',
			acceptAllBtn: 'Enable all cookies',
			acceptSelectedBtn: 'Enable selected cookies',
			checkboxStateOff: 'OFF',
			checkboxStateOn: 'ON',
			closeBtn: 'Close',
			technicalTitle: 'Technical cookies',
			technicalPerex: 'Technical cookies are necessary for the website to be displayed and operate properly.',
			technicalState: 'Always ON',
			analyticsMarketingTitle: 'Analytical and marketing cookies',
			analyticsTitle: 'Analytical cookies',
			analyticsPerex: 'Analytical cookies help to analyze how our website works in terms of visitor behavior and to adapt and change the website accordingly.',
			marketingTitle: 'Marketing cookies (ad personalization, remarketing)',
			marketingPerex: 'They allow us and our partners (e.g. Google) to show personalized ads - even on other websites you visit. You can find more about how Google works with data in the <a class="cookies-settings__link" href="https://business.safety.google/privacy/">Google Privacy & Terms</a>.',
		},
		se: {
			heading: 'Cookies settings',
			perex: 'You can set which cookies will be processed here. For more information, please go to <a class="cookies-settings__link" href="/se/information-om-webben">Cookie information</a>',
			acceptAllBtn: 'Enable all cookies',
			acceptSelectedBtn: 'Enable selected cookies',
			checkboxStateOff: 'OFF',
			checkboxStateOn: 'ON',
			closeBtn: 'Close',
			technicalTitle: 'Technical cookies',
			technicalPerex: 'Technical cookies are necessary for the website to be displayed and operate properly.',
			technicalState: 'Always ON',
			analyticsMarketingTitle: 'Analytical and marketing cookies',
			analyticsTitle: 'Analytical cookies',
			analyticsPerex: 'Analytical cookies help to analyze how our website works in terms of visitor behavior and to adapt and change the website accordingly.',
			marketingTitle: 'Marketing cookies (ad personalization, remarketing)',
			marketingPerex: 'They allow us and our partners (e.g. Google) to show personalized ads - even on other websites you visit. You can find more about how Google works with data in the <a class="cookies-settings__link" href="https://business.safety.google/privacy/">Google Privacy & Terms</a>.',
		},
		ru: {
			perex: 'Здесь вы можете указать, какие файлы cookie мы будем обрабатывать. Более подробную информацию см. на странице <a class="cookies-settings__link" href="/ru/information-about-the-web">использованием cookies</a>',
			marketingTitle: 'Маркетинговые файлы cookie (персонализация рекламы, ремаркетинг)',
		},
	},
});



// WEBPACK FOOTER //
// ./fe/web-bn/src/js/configureWeb.js